import StoreInfo from './StoreInfo';

export default StoreInfo;
